/* eslint-disable jsx-a11y/label-has-associated-control */
import { Empty, Input } from 'antd';
import React, { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { log } from 'utils';
import 'react-quill/dist/quill.snow.css';
import { fetchInformationCategories } from 'state/actions/informationCategories';
import { setInformation } from 'state/actions/information';
import './AddWebPagesForm.css';

import { EmptyIcon } from 'assets/icon/bigicon';
import DummyTemplateImage from 'assets/dummy-template/dummy-1.png';
import AddSection from './AddSection';
import { addWebPages, updateWebPages } from 'state/actions/webPages';
import { toastr } from 'react-redux-toastr';
import { imgUrl } from 'utils/url';
import { fetchWebLayout } from 'state/actions/webLayout';
import {
  addWebTemplate,
  fetchWebTemplates,
  updateWebTemplate,
} from 'state/actions/webTemplates';

const AddWebPagesForm = ({ error, onClose, predefinedData }) => {
  const { siteId, siteName } = useParams();
  const [editingSection, setEditingSection] = useState(null);
  log(error);

  useEffect(() => {
    if (!predefinedData) return;

    dispatch(
      setInformation({
        ...information,
        name: predefinedData.title || '',
        url: predefinedData.url || '',
      })
    );

    if (predefinedData.sections && predefinedData.sections.length > 0) {
      const mappedSections = predefinedData.sections.map((sec) => ({
        id: sec._id || Date.now() + Math.random(),
        sectionId: sec.sectionId,
        templateLayoutId: sec.templateLayoutId,
        sectionTitle: sec.sectionTitle,
        blocks: sec.blocks || [],
        isFromTemplate: sec.isFromTemplate,
        // templateId: sec.isFromTemplate ? sec.templateLayoutId : null,
      }));
      setSections(mappedSections);
    }
  }, [predefinedData]);

  const [errors, setErrors] = useState(error);

  useEffect(() => {
    setErrors(error);
  }, [error]);

  const {
    loading,
    userData,
    categoriesList,
    poiList,
    information,
    category,
    webLayoutData,
    webTemplateData,
  } = useSelector(
    (state) => ({
      loading: state.information.loading,
      userData: state.auth.userData,
      categoriesList: state.informationCategories.list,
      poiList: state.pois.list,
      information: state.information.information,
      category: state.informationCategories.category,
      webLayoutData: state.webLayout.list,
      webTemplateData: state.webTemplate.list,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(fetchWebLayout({ siteId }));
    dispatch(fetchWebTemplates({ siteId }));
  }, []);

  const uid = userData.id;

  const dispatch = useDispatch();
  const [tempSelectedCategory, setTempSelectedCategory] = useState();
  const [sections, setSections] = useState([]);

  const [columnOne, setColumnOne] = useState('80%');
  const [columnTwo, setColumnTwo] = useState('20%');

  const [openAddSection, setOpenAddSection] = useState(false);
  const [selectedTitlePagesContainer, setSelectedTitlePagesContainer] =
    useState(true);
  const [selectedSection, setSelectedSection] = useState(null);

  const [selectedLayout, setSelectedLayout] = useState('');
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);

  useEffect(() => {
    if (information) {
      setTempSelectedCategory(information.categoryId);
    }
  }, [information]); // eslint-disable-line

  const handleChange = (name, value) => {
    dispatch(
      setInformation({
        ...information,
        [name]: value,
      })
    );
  };

  const saveWebTemplatePerSection = async () => {
    for (const section of sections) {
      if (!section.saveAsTemplate) continue;

      const formData = new FormData();

      formData.append('sectionId', section.sectionId);
      formData.append('templateId', section.templateLayoutId || '');

      formData.append('sectionTitle', section.sectionTitle || '');
      formData.append('siteId', siteId);
      formData.append('logo', section.logo || '');

      section.blocks.forEach((block, i) => {
        formData.append(`content[${i}][type]`, block.type);
        formData.append(`content[${i}][variable]`, block.variable);

        if (block.type === 'image' && block.file) {
          formData.append(`content[${i}][file]`, block.file);
        } else {
          formData.append(`content[${i}][value]`, JSON.stringify(block.value));
        }
      });

      if (section._id) {
        await dispatch(updateWebTemplate(section._id, formData));
      } else {
        await dispatch(addWebTemplate(formData));
      }
    }
  };

  const onSubmitHandler = async (event) => {
    try {
      event.preventDefault();

      await saveWebTemplatePerSection();

      const formData = new FormData();

      formData.append('title', information.name);
      formData.append('siteId', siteId);
      formData.append('url', information.url || '');
      formData.append('userId', userData.id);
      sections.forEach((section, index) => {
        formData.append(
          `sections[${index}][sectionId]`,
          section.sectionId || ''
        );
        formData.append(
          `sections[${index}][templateId]`,
          section.templateLayoutId || section.templateId || ''
        );
        formData.append(
          `sections[${index}][isFromTemplate]`,
          section.isFromTemplate ? 'true' : 'false'
        );

        section.blocks.forEach((block, bIndex) => {
          formData.append(
            `sections[${index}][blocks][${bIndex}][type]`,
            block.type
          );

          formData.append(
            `sections[${index}][blocks][${bIndex}][variable]`,
            block.variable
          );

          if (block.type === 'image' && block.file) {
            formData.append(
              `sections[${index}][blocks][${bIndex}][file]`,
              block.file
            );
          } else {
            formData.append(
              `sections[${index}][blocks][${bIndex}][value]`,
              JSON.stringify(block.value)
            );
          }
        });

        formData.append(
          `sections[${index}][sectionTitle]`,
          section.sectionTitle || ''
        );

        if (section?.file && section.file[0]?.file) {
          formData.append(`sections[${index}][file]`, section.file[0].file);
        }
      });

      if (predefinedData && predefinedData._id) {
        dispatch(updateWebPages(predefinedData._id, formData, () => onClose()));
      } else {
        dispatch(addWebPages(formData, () => onClose()));
      }
    } catch (error) {}
  };

  const addNewSection = () => {
    setSelectedSection(null);

    setColumnOne('240px');
    setColumnTwo('100%');
    setOpenAddSection(true);
  };

  const closeAddNewSection = (e) => {
    e.stopPropagation();
    setColumnOne('80%');
    setColumnTwo('20%');
    setOpenAddSection(false);
  };

  // const handleAddSection = (newSection, editingSection) => {
  //   // if (editingSection && !newSection.isFromTemplate) {
  //   if (editingSection) {
  //     setSections((prev) =>
  //       prev.map((sec) => {
  //         console.log(sec, editingSection);
  //         return sec.id === editingSection.id ? newSection : sec;
  //       })
  //     );
  //   } else {
  //     setSections((prev) => [...prev, newSection]);
  //   }

  //   setColumnOne('80%');
  //   setColumnTwo('20%');
  //   setOpenAddSection(false);
  //   setSelectedSection(null);
  // };

  const handleAddSection = (newSection, editingSection) => {
    const isEditing =
      editingSection && sections.some((sec) => sec.id === editingSection.id);
    if (isEditing) {
      setSections((prev) =>
        prev.map((sec) => (sec.id === editingSection.id ? newSection : sec))
      );
    } else {
      setSections((prev) => [...prev, newSection]);
    }

    setEditingSection(null);
    setColumnOne('80%');
    setColumnTwo('20%');
    setOpenAddSection(false);
    setSelectedSection(null);
  };

  const handleRemoveSection = (id) => {
    setSections((prev) => prev.filter((section) => section.id !== id));
  };

  const handleEditSection = (section) => {
    setEditingSection(section);
    setSelectedSection(section);
    if (section.isFromTemplate && section.templateLayoutId) {
      setSelectedTitlePagesContainer(false);
      const template = sections.find((t) => t.id === section.id);
      if (template) {
        template.content = template.blocks;
        setSelectedLayout({
          ...template,
          isFromTemplate: true,
        });
        setSelectedTemplateId(template.templateLayoutId);

        setSelectedSection({
          ...section,
          blocks: template.content,
          isFromTemplate: true,
        });
      } else {
        const layout = predefinedData.sections.find(
          (l) =>
            l.templateLayoutId === section.templateLayoutId && l.isFromTemplate
        );
        layout.content = layout.blocks;

        setSelectedLayout({
          ...layout,
          isFromTemplate: true,
        });

        setSelectedTemplateId(template.templateLayoutId);

        setSelectedSection({
          ...section,
          blocks: layout.blocks,
          isFromTemplate: true,
        });
      }
    } else {
      setSelectedTitlePagesContainer(true);
      const layout = webLayoutData.find(
        (l) => l._id === section.templateLayoutId
      );

      if (layout) {
        setSelectedLayout({
          ...layout,
          isFromTemplate: false,
        });
      }

      setSelectedSection(section);
    }

    setColumnOne('240px');
    setColumnTwo('100%');
    setOpenAddSection(true);
  };

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(sections);
    const [moved] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, moved);

    setSections(items);
  };

  const sectionOne = () => {
    return (
      <div className="section-body">
        <div
          style={{
            width: columnOne,
            height: '100vh',
          }}
        >
          <form className="form-wrapper">
            <div>
              <div className="form">
                <label className="form-label">
                  Title <span className="is-required">*</span>
                </label>
                <Input
                  placeholder="Enter Title"
                  className={`${
                    errors && errors.errors && errors.errors.name
                      ? 'has-error'
                      : ''
                  }`}
                  name="name"
                  value={information.name}
                  onChange={(e) => handleChange('name', e.target.value)}
                />
                {errors && errors.errors && errors.errors.name && (
                  <span className="error-message">
                    {errors.errors.name[0].msg}
                  </span>
                )}
              </div>

              <div className="form">
                <label className="form-label">Url</label>
                <Input
                  placeholder="Enter Url"
                  name="url"
                  type="text"
                  value={information.url}
                  onChange={(e) => handleChange('url', e.target.value)}
                />
                {errors &&
                  errors.errors &&
                  errors.errors.url &&
                  errors.errors.url.map((name, idx) => (
                    <div className="error-message" key={idx}>
                      {name.msg}
                    </div>
                  ))}
              </div>

              <div className="form">
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}
                >
                  <label className="form-label">Section</label>

                  <div onClick={addNewSection}>
                    <span
                      style={{
                        color: '#64D5D2',
                        fontSize: '16px',
                        fontWeight: '700',
                        cursor: 'pointer',
                      }}
                    >
                      + Add Section
                    </span>
                  </div>
                </div>

                {sections.length === 0 ? (
                  <div className="web-page-empty">
                    <Empty image={<EmptyIcon />} description="No Section" />
                  </div>
                ) : (
                  <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId="sections">
                      {(provided) => (
                        <div
                          className="section-list"
                          ref={provided.innerRef}
                          {...provided.droppableProps}
                        >
                          {sections.map((section, index) => (
                            <Draggable
                              key={section.id}
                              draggableId={section.id.toString()}
                              index={index}
                            >
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  className="section-item"
                                  onClick={() => handleEditSection(section)}
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '8px 12px',
                                    border: '1px solid #eee',
                                    borderRadius: '4px',
                                    marginBottom: '8px',
                                    background: '#fff',
                                    ...provided.draggableProps.style,
                                  }}
                                >
                                  <div>
                                    {section.template && (
                                      <img
                                        src={
                                          section.file?.[0]?.preview ||
                                          section.blocks?.find(
                                            (b) => b.type === 'image'
                                          )?.value
                                            ? `${imgUrl}/media/${
                                                section.blocks.find(
                                                  (b) => b.type === 'image'
                                                )?.value
                                              }`
                                            : section.template?.image
                                        }
                                        style={{
                                          width: '60px',
                                          height: '40px',
                                          objectFit: 'cover',
                                          borderRadius: '4px',
                                          border: '1px solid #eee',
                                        }}
                                      />
                                    )}

                                    <div style={{ fontWeight: 600 }}>
                                      {section.sectionId}
                                      {section.saveAsTemplate && (
                                        <span
                                          style={{
                                            marginLeft: 8,
                                            color: 'green',
                                          }}
                                        >
                                          (Template)
                                        </span>
                                      )}
                                    </div>
                                  </div>

                                  <button
                                    type="button"
                                    className="button-secondary"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleRemoveSection(section.id);
                                    }}
                                    style={{
                                      background: '#ff4d4f',
                                      color: 'white',
                                      border: 'none',
                                      padding: '4px 8px',
                                      borderRadius: '4px',
                                      cursor: 'pointer',
                                    }}
                                  >
                                    Remove
                                  </button>
                                </div>
                              )}
                            </Draggable>
                          ))}

                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                )}
              </div>
            </div>
          </form>
          <div
            className="button-wrapper"
            style={{ display: 'flex', justifyContent: 'flex-end' }}
          >
            <div>
              {loading ? (
                <button className="button-primary" disabled>
                  Loading...
                </button>
              ) : (
                <button className="btn-primary" onClick={onSubmitHandler}>
                  Submit
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const sectionTwo = () => {
    return (
      <div className="section-body">
        <div
          style={{
            width: columnOne,
            height: '100vh',
            background: '#F2F2F2',
            overflowY: 'auto',
          }}
          className="column-one"
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              width: '240px',
            }}
          >
            <div
              className="title-container"
              style={{
                background: selectedTitlePagesContainer ? '#DBF5F5' : '#FFFFFF',
                borderBottom: selectedTitlePagesContainer
                  ? '2px solid #64D5D2'
                  : 'none',
                color: selectedTitlePagesContainer ? '#404040' : '#9E9E9E',
              }}
              onClick={() => setSelectedTitlePagesContainer(true)}
            >
              <span className="text">Layout</span>
            </div>

            <div
              className="title-container"
              onClick={() => setSelectedTitlePagesContainer(false)}
              style={{
                background: !selectedTitlePagesContainer
                  ? '#DBF5F5'
                  : '#FFFFFF',
                borderBottom: !selectedTitlePagesContainer
                  ? '2px solid #64D5D2'
                  : 'none',
                color: !selectedTitlePagesContainer ? '#404040' : '#9E9E9E',
              }}
            >
              <span className="text">Template</span>
            </div>
          </div>
          <div className="body-container">
            <div className="searchbar">
              <i className="feather-search" />
              <input placeholder="Search" className="search-input" />
            </div>

            <div
              style={{
                marginTop: '12px',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                alignContent: 'center',
              }}
            >
              {selectedTitlePagesContainer &&
                webLayoutData.map((data) => {
                  return (
                    <div
                      style={{
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        alignContent: 'center',
                        justifyItems: 'center',
                        gap: '8px',
                        padding: '4px',
                        border:
                          selectedLayout?._id === data._id &&
                          !selectedLayout.isFromTemplate
                            ? '2px solid #64D5D2'
                            : '',
                      }}
                      onClick={() =>
                        setSelectedLayout({
                          ...data,
                          isFromTemplate: false,
                        })
                      }
                    >
                      <img
                        src={`${imgUrl}/media/${data.logo}`}
                        style={{
                          width: '200px',
                          height: '140px',
                          objectFit: 'contain',
                        }}
                      />
                      <center>
                        <span
                          style={{
                            fontWeight: 'bold',
                          }}
                        >
                          {data.title}
                        </span>
                      </center>
                    </div>
                  );
                })}

              {!selectedTitlePagesContainer &&
                webTemplateData.map((data) => {
                  return (
                    <div
                      style={{
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        alignContent: 'center',
                        justifyItems: 'center',
                        gap: '8px',
                        padding: '4px',
                        border:
                          selectedTemplateId === data.templateLayoutId
                            ? '2px solid #64D5D2'
                            : '',
                      }}
                      onClick={() => {
                        const layout = webLayoutData.find(
                          (l) => l._id === data.templateLayoutId
                        );

                        setSelectedLayout({
                          ...layout,
                          isFromTemplate: true,
                        });
                        setSelectedTemplateId(data._id);

                        setSelectedSection({
                          sectionId: data.sectionId,
                          sectionTitle: data.sectionTitle,
                          templateLayoutId: data.templateLayoutId,
                          templateId: data._id,
                          blocks: data.content,
                          isFromTemplate: true,
                        });

                        setEditingSection(null);
                      }}
                    >
                      <img
                        src={`${imgUrl}/media/${data.logo}`}
                        style={{
                          width: '200px',
                          height: '140px',
                          objectFit: 'contain',
                        }}
                      />
                      <center>
                        <span
                          style={{
                            fontWeight: 'bold',
                          }}
                        >
                          {data.sectionTitle}
                        </span>
                      </center>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        <div
          className="column-two body-section"
          style={{
            width: columnTwo,
            eight: '100vh',
            overflowY: 'auto',
            position: 'relative',
          }}
        >
          <div
            style={{
              top: '0',
              right: '0',
              position: 'absolute',
            }}
            className="button-secondary"
            onClick={closeAddNewSection}
          >
            <i className="feather-arrow-left" />
            Back
          </div>
          <AddSection
            onAdd={handleAddSection}
            selectedSection={selectedSection}
            selectedLayout={selectedLayout}
          />
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        padding: '12px 20px',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <span
          style={{
            fontSize: '24px',
            fontWeight: 700,
          }}
        >
          Add Page
        </span>
        <div
          style={{
            top: '0',
            right: '0',
            position: 'absolute',
          }}
          onClick={onClose}
          className="button-secondary"
        >
          <i className="feather-arrow-left" />
          Back
        </div>
      </div>

      <div className="addWebPagesForm">
        {!openAddSection && sectionOne()}

        {openAddSection && sectionTwo()}
      </div>
    </div>
  );
};

export default AddWebPagesForm;
